import { render } from "./workflowphase-list.vue?vue&type=template&id=40956537"
import script from "./workflowphase-list.vue?vue&type=script&lang=js"
export * from "./workflowphase-list.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__